import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Button } from 'antd'
import { CertificateType } from 'enum/certificateType.enum'
import { IBasicCourse } from 'interfaces/course'
import { certificatesService } from 'api/administration/certificates'
import { useNotification } from 'hooks/notifications/useNotification'
import Type from './type'
import { Wrapper, Header, Subtitle, Buttons } from './styled'
import Courses from './courses'

interface IProps {
  certificateId: number
  setCertificateId: (value: number) => void
}

const AssociationOfCourses = ({ certificateId, setCertificateId }: IProps) => {
  const { t } = useTranslation()
  const notification = useNotification()
  const [type, setType] = useState(CertificateType.individual)
  const [courses, setCourses] = useState<IBasicCourse[]>([])
  const translatePrefix = 'administration.certificate.new'

  useEffect(() => {
    getConfiguration()
  }, [])

  const getConfiguration = () => {
    certificatesService.getConfiguration(certificateId).then((response) => {
      setType(response.data.data.attributes.certificateType)
      setCourses(
        response.data.data.attributes.certificateCourseAttributes.map(
          (item) => ({ ...item, id: item.courseId })
        )
      )
    })
  }

  const saveConfiguration = () => {
    certificatesService
      .saveConfiguration(certificateId, type, courses)
      .then(() => {
        notification.success(
          t(`${translatePrefix}.notifications.associatedCourses`)
        )
        setCertificateId(0)
      })
      .catch(() => {
        notification.warning(
          t(`${translatePrefix}.notifications.errorAssociatingCourses`)
        )
      })
  }

  return (
    <Wrapper id="association-of-courses">
      <Header>
        <FontAwesomeIcon
          onClick={() => setCertificateId(0)}
          icon={faArrowLeft as IconProp}
        />
        <span>{t(`${translatePrefix}.header.title`)}</span>
      </Header>
      <Subtitle>{t(`${translatePrefix}.types.title`)}</Subtitle>
      <Type value={type} setValue={setType} />
      <Subtitle>{t(`${translatePrefix}.courses.titleV2`)}</Subtitle>
      <Courses data={courses} setData={setCourses} />
      <Buttons>
        <Button onClick={() => setCertificateId(0)}>
          {t(`${translatePrefix}.buttons.cancel`)}
        </Button>
        <Button onClick={saveConfiguration} disabled={courses.length === 0}>
          {t(`${translatePrefix}.buttons.saveConfiguration`)}
        </Button>
      </Buttons>
    </Wrapper>
  )
}

export default AssociationOfCourses
